import * as React from 'react';
import { connect } from 'react-redux';

import DropdownInput from './DropdownInput';
import { PickListType } from '../../common/utils';

interface CountryOption {
	text: string;
	value: string;
}
const defaultCountryOptions: CountryOption[] = [
	{
		text: '',
		value: ''
	}
];

export interface CountryDropdownProps {
	// passed props
	country: string;
	onBlur?: (e: any) => void;
	onChange: (e: any) => void;
	labelText?: string;
	name?: string;
	className?: string;
	required?: boolean;

	// own props
	countries: PickListItem[];
}
class CountryDropdown extends React.Component<CountryDropdownProps> {
	countryOptions = defaultCountryOptions;
	constructor(props: CountryDropdownProps) {
		super(props);
		this.countryOptions = this.props.countries.map((p: PickListItem) => {
			return { text: p.description!, value: p.description! };
		});
	}

	componentWillReceiveProps(nextProps: CountryDropdownProps) {
		this.countryOptions = nextProps.countries.map((p: PickListItem) => {
			return { text: p.description!, value: p.description! };
		});
	}

	render() {
		return (
			<DropdownInput
				labelText={this.props.labelText}
				name={this.props.name || 'country'}
				defaultOption="-"
				options={this.countryOptions}
				onBlur={this.props.onBlur}
				onChange={this.props.onChange}
				value={this.props.country || ''}
				className={this.props.className}
				required={this.props.required}
			/>
		);
	}
}

function mapStateToProps(state: any, ownProps: any) {
	let countries;
	if (ownProps.countries) {
		countries = ownProps.countries;
	} else {
		countries = state.pickList.items.filter((p: PickListItem) => p.pickListTypeId === PickListType.Countries);
	}

	return {
		countries: countries
	};
}
export default connect(mapStateToProps)(CountryDropdown);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/forms/CountryDropdown.tsx